import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { SERVER_API_URL } from "src/app/app.constants";
import { User } from "./user.model";
import * as Sentry from "@sentry/browser";
import { BehaviorSubject, Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { OAuthService, OAuthStorage } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";
export const ACCESS_TOKEN_KEY = "access_token";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private currentUserSubject: BehaviorSubject<User>;
  private userRegions = new Set<string>();

  USER_API_BASE_URL = SERVER_API_URL + "spectrum/user";

  constructor(
    private httpClient: HttpClient,
    private oauthService: OAuthService,
    private authStorage: OAuthStorage
  ) {
    const user = this.parseToken(this.getToken());
    //console.log(user);
    this.addUserDetailsToSentry(user);
    this.currentUserSubject = new BehaviorSubject<User>(user);
  }

  private parseToken(token: string): User {
    const helper = new JwtHelperService();
    if (token) {
      const user = helper.decodeToken(token);
      return user;
    }
    return null;
  }

  public getToken(): string {
    const accessToken = this.authStorage.getItem(ACCESS_TOKEN_KEY);
    if (accessToken) {
      return accessToken;
    } else {
      return null;
    }
  }

  loginSso(redirectUrlAfterLogin: string): void {
    this.oauthService.setupAutomaticSilentRefresh();

    //console.log('before redirect url : '+decodeURIComponent(redirectUrlAfterLogin));
    this.oauthService
      .loadDiscoveryDocumentAndLogin({ state: redirectUrlAfterLogin })
      .then((result) => {
        if (result && redirectUrlAfterLogin) {
          const url = decodeURIComponent(this.oauthService.state);
          //console.log('after redirect url : '+url);
          window.location.href = url;
          // (environment.production ? "/spectrum" : "") + url;
        }
      })
      .catch((error) => {
        console.log("error on login : redirecting to logout :" + error);
        //this.logout();
      });
  }

  // loginSso(redirectUrlAfterLogin: string): Promise<void> {
  //   this.oauthService.setupAutomaticSilentRefresh();
  //   return this.oauthService
  //     .loadDiscoveryDocumentAndLogin({ state: redirectUrlAfterLogin })
  //     .then((hasReceivedTokens) => {
  //       if (hasReceivedTokens) {
  //         // carry on with your app
  //         //
  //         // if (redirectUrlAfterLogin) {
  //         //   const url = decodeURIComponent(this.oauthService.state);
  //         //   //console.log('after redirect url : '+url);
  //         //   window.location.href = url;
  //         // }
  //         return Promise.resolve();

  //         /* if you wish to do something when the user receives tokens from the identity server,
  //          * use the event stream or the `onTokenReceived` callback in LoginOptions.
  //          *
  //          * oauthService.events.pipe(filter(event => event.type === 'token_received')).subscribe((event)=>console.log(event))
  //          */
  //       } else {
  //         // may want to check if you were previously authenticated
  //         if (this.isAuthenticated()) {
  //           return Promise.resolve();
  //         } else {
  //           // to safe guard this from progressing through the calling promise,
  //           // resolve it when it directed to the sign up page
  //           return new Promise((resolve) => {
  //             this.oauthService.initLoginFlow();
  //             // example if you are using explicit flow
  //             Promise.resolve();
  //           });
  //         }
  //       }
  //     });
  // }

  isAuthenticated(): boolean {
    if (
      this.oauthService.hasValidAccessToken() &&
      this.oauthService.hasValidIdToken()
    ) {
      return true;
    } else {
      return false;
    }
  }

  logOut() {
    //this.cookieService.delete(this.JWT_COOKIE_KEY,  ' / ' );
    this.userRegions = new Set();
    this.currentUserSubject.next(null);
    this.addUserDetailsToSentry(null);
    this.oauthService.logOut();
  }

  getUser(): User {
    if (!this.currentUserSubject.value) {
      const user = this.parseToken(this.getToken());
      this.addUserDetailsToSentry(user);
      this.currentUserSubject.next(user);
    }
    return this.currentUserSubject.value;
    //return this.user;
  }

  // loadUser(): Promise<any>{

  //   const promise = this.httpClient
  //               .get(this.USER_API_BASE_URL)
  //               .toPromise()
  //               .then((response : User) => {
  //                 this.user=response;
  //                 this.addUserDetailsToSentry(response);
  //               });
  //   return promise;
  // }

  userHasAccessToRegion(region: string) {
    return this.getRegions().includes(region);
  }

  getRegions(): string[] {
    if (this.userRegions.size == 0) {
      this.setRegions(this.getUser());
    }
    return Array.from(this.userRegions);
  }

  private setRegions(user: User) {
    if (user && user.applications) {
      user.applications.forEach((app: string) => {
        if (app === "ALL") {
          this.userRegions.add("EU");
          this.userRegions.add("LN");
        } else {
          const separator = "-";
          if (app.includes(separator)) {
            let splitArray = app.split(separator);
            if (splitArray.length === 3) {
              const appName = splitArray[0];
              if (appName.startsWith("SpectrumDb")) {
                this.userRegions.add(splitArray[2]);
              }
            }
          }
        }
      });
    }
  }

  addUserDetailsToSentry(user: User) {
    if (user) {
      Sentry.setUser({ id: user.id });
    } else {
      Sentry.setUser(null);
    }
  }
}
